import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { RouterLink } from '@angular/router';
import { FolderDto, GalleryDto } from '@nusign/picflow-backend-types';
import { firstValueFrom } from 'rxjs';
import { DialogOptions } from '../../../interfaces/dialog-data.interface';
import { ChecklistService } from '../../../services/checklist.service';
import { OnGetData } from '../../../services/dialog.service';
import { ObservableDataLoaderService } from '../../../services/observable-data-loader.service';
import { OrganizationService } from '../../../services/organization.service';
import { StateService } from '../../../services/state.service';
import { LoadingIndicatorComponent } from '../../../shared/components/loading-indicator/loading-indicator.component';
import { ButtonDirective } from '../../../shared/directives/button.directive';
import { CreateTenantFormComponent } from '../../components/create-tenant-form/create-tenant-form.component';

@Component({
  selector: 'app-workspace-dialog',
  templateUrl: './workspace-dialog.component.html',
  styleUrls: ['./workspace-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CreateTenantFormComponent, RouterLink, ButtonDirective, LoadingIndicatorComponent],
})
export class WorkspaceDialogComponent implements OnGetData {
  public state = inject(StateService);
  private organizationService = inject(OrganizationService);
  private checklistService = inject(ChecklistService);
  private observableLoader = inject(ObservableDataLoaderService);
  dialogName = 'workspace';
  close: (...args) => void;
  onDone: () => void;
  loading = signal(false);
  initialValue = signal<{ name: string; path: string }>(undefined);
  item: GalleryDto | FolderDto;
  activeTenant = toSignal(this.state.activeTenant$);

  dialogOptions(): DialogOptions {
    return { size: 480, spacingX: 40 };
  }

  onGetData(data: { item: GalleryDto | FolderDto; onDone: () => unknown }, close: (...args) => void) {
    this.close = close;
    this.onDone = data.onDone;
    this.item = data.item;
    this.initialValue.set({ name: `${this.state.user.first_name}'s Workspace`, path: this.activeTenant().path });
  }

  async confirmWorkSpace(event: { name: string; path: string }) {
    if (this.loading()) return;
    this.loading.set(true);
    await this.organizationService.updateOrganization({
      name: event.name,
      slug: event.path,
    });
    await firstValueFrom(this.checklistService.markItemAsDone('setWorkspaceName'));
    this.observableLoader.removeFuzzy('galleries');
    if (this.item?.['tenant']?.['id']) {
      this.item['tenant']['path'] = event.path;
    }
    this.onDone?.();
  }
}
